import { QueryClientConfig } from '@tanstack/react-query';

import { HttpError } from 'src/shared/utils/HttpError';

const MAX_QUERY_RETRIES = 3;

const isClientHttpError = (error: unknown): boolean =>
  error instanceof HttpError && error.status >= 400 && error.status < 500;

export const shouldRetryQuery = (failureCount: number, error: unknown): boolean =>
  !isClientHttpError(error) && failureCount < MAX_QUERY_RETRIES;

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 2 * 60 * 1000,
      retry: shouldRetryQuery,
    },
  },
};
